import { Avatar, Button, ListItem, Stack, Typography } from '@mui/material';
import { MedicalReferralItem } from 'API/Home/userUpdates';
import { requestFile } from 'API/medicalReferrals';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useLoader } from 'Hooks/useLoader';
import { PurpleDownloadIcon } from 'Images';
import { downloadFile } from 'Utils';

interface IReferralListItem {
  index: number;
  item: MedicalReferralItem;
}

export const ReferralListItem = ({ index, item }: IReferralListItem) => {
  const { isLoading, loader, setIsLoading } = useLoader(
    'scale(0.25)',
    undefined,
    undefined,
    false
  );

  const download = async (
    e: React.MouseEvent<HTMLElement, MouseEvent>,
    id: string
  ) => {
    setIsLoading(true);
    e.stopPropagation();
    const file = await requestFile(parseInt(id));
    setIsLoading(false);
    if (file && file.fileContentBase64) {
      downloadFile(
        file.fileContentBase64,
        'pdf',
        file.documentName || 'New Document'
      );
    }
  };

  return (
    <ListItem key={index} sx={{ p: 0 }}>
      <Stack
        sx={{
          flexDirection: 'row',
          borderBottom: '1px solid',
          borderColor: 'primary.shade_100',
          p: '12px 0',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant='body6' sx={{ fontWeight: 600 }}>
          {item.Subject}
        </Typography>
        {isLoading ? (
          <Stack
            height={'40px'}
            justifyContent={'center'}
            alignItems={'end'}
            width={'auto'}
          >
            {loader}
          </Stack>
        ) : (
          <Button
            onClick={(e) => download(e, item.Id)}
            startIcon={
              <Avatar
                src={PurpleDownloadIcon}
                alt=''
                sx={{ width: '22px', height: '22px' }}
              />
            }
            sx={{
              fontSize: '16px',
              color: 'primary.secondary',
              fontWeight: 600,
              pr: '20px',
            }}
          >
            {Dictionary[DICTIONARY.Home].userUpdates.toDownload}
          </Button>
        )}
      </Stack>
    </ListItem>
  );
};
